import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Row, Col, Input, Card, CardBody, Form, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../services/apiServices";

const LeaguesList = () => {
  const navigate = useNavigate();
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredLeagues, setFilteredLeagues] = useState([]);

  // Fetch leagues
  const fetchLeagues = async () => {
    try {
      setLoading(true);
      const response = await fetchData("api/admin/getAllleagues");
      setLeagues(response.data || []);
      setFilteredLeagues(response.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching leagues:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeagues();
  }, []);

  // Handle search input
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value === "") {
      setFilteredLeagues(leagues);
    } else {
      const filtered = leagues.filter(
        (league) =>
          league.name.toLowerCase().includes(value.toLowerCase()) ||
          league.sub_category.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredLeagues(filtered);
    }
  };

  // Handle edit click (placeholder for now)
  const handleEditClick = (league) => {
    navigate(`/leagues/edit/${league._id}`);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">League Image</span>,
      cell: (row) => (
        <div style={{ padding: "5px" }}>
          {row.image ? (
            <img
              src={row.image}
              alt={row.name}
              style={{
                width: "40px",
                height: "40px",
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          ) : (
            <div
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#f0f0f0",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#999",
              }}
            >
              No Image
            </div>
          )}
        </div>
      ),
      width: "100px",
    },
    {
      name: <span className="font-weight-bold fs-13">League Name</span>,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "100%",
          }}
        >
          {row.name}
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="font-weight-bold fs-13">Sub Category</span>,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {row.sub_category?.name || "N/A"}
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="font-weight-bold fs-13">Category</span>,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
          }}
        >
          {row.sub_category?.category || "N/A"}
        </div>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="font-weight-bold fs-13">Created At</span>,
      cell: (row) => <div>{new Date(row.createdAt).toLocaleDateString()}</div>,
      sortable: true,
      grow: 1,
    },
    {
      name: <span className="font-weight-bold fs-13">Actions</span>,
      cell: (row) => (
        <Button
          color="primary"
          size="sm"
          onClick={(e) => {
            e.stopPropagation();
            handleEditClick(row);
          }}
        >
          Edit
        </Button>
      ),
      width: "100px",
      ignoreRowClick: true,
    },
  ];

  return (
    <Card>
      <CardBody>
        <Form>
          <Row className="mb-3">
            <Col lg="4">
              <Input
                type="search"
                placeholder="Search leagues..."
                value={searchText}
                onChange={handleSearchChange}
              />
            </Col>
          </Row>
        </Form>

        <DataTable
          columns={columns}
          data={filteredLeagues}
          pagination
          progressPending={loading}
          responsive
          highlightOnHover
          pointerOnHover
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30, 50]}
        />
      </CardBody>
    </Card>
  );
};

export default LeaguesList;
